import { render, staticRenderFns } from "./AppCompanyProfile.vue?vue&type=template&id=de27b6fc&"
import script from "./AppCompanyProfile.vue?vue&type=script&lang=js&"
export * from "./AppCompanyProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports